import { render, staticRenderFns } from "./AffiliateCustomerCreate.vue?vue&type=template&id=bafb110a&"
import script from "./AffiliateCustomerCreate.vue?vue&type=script&lang=js&"
export * from "./AffiliateCustomerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports